import {
	PHARMACY_PATIENT_NOTIFICATIONS_REQUEST,
	PHARMACY_PATIENT_NOTIFICATIONS_SUCCESS,
	PHARMACY_PATIENT_NOTIFICATIONS_FAILURE,
	PHARMACY_PATIENT_NOTIFICATIONS_RESET,
	PHARMACY_PATIENT_NOTIFICATIONS_REFRESH_PAGE,
	PHARMACY_PATIENT_NOTIFICATIONS_UPDATE_NOTE
} from '../../../constants';

import * as pdf from '../forms/previewPdf'

import Axios from '../../../../networking/intraceptor'
import { p_reminder_nofication, pharmacy_patient_notification_list, pharmacy_delete_all_system_generated_notes } from '../../../../networking/urlEndPoints'
import { PreviewPdf, showToast } from '../../../../utils/helper/helper';

export const pharmacyPatientNotificationsRequest = (types) => ({
	type: PHARMACY_PATIENT_NOTIFICATIONS_REQUEST,
	types: types
});

export const pharmacyPatientNotificationsSuccess = (data, types, appendData = false) => ({
	type: PHARMACY_PATIENT_NOTIFICATIONS_SUCCESS,
	payload: data,
	types: types,
	appendData: appendData
});

export const pharmacyPatientNotificationsRefreshPage = (data, currentPage, types) => ({
	type: PHARMACY_PATIENT_NOTIFICATIONS_REFRESH_PAGE,
	payload: data,
	currentPage: currentPage,
	types: types
});

export const pharmacyPatientNotificationsFailure = (error, types) => ({
	type: PHARMACY_PATIENT_NOTIFICATIONS_FAILURE,
	payload: error,
	types: types
});

export const resetPatientNotifications = () => ({
	type: PHARMACY_PATIENT_NOTIFICATIONS_RESET
});

// Update a specific note locally (e.g., add reply, update pin, etc.)
export const updatePatientNote = (noteId, updateData, updateType) => ({
	type: PHARMACY_PATIENT_NOTIFICATIONS_UPDATE_NOTE,
	payload: { noteId, updateData, updateType }
});

export const fetchPatientNotifications = (page, setAddTeamNoteData, addTeamNoteData, type, types = "fetchPatientNotifications", appendData = false, backgroundRefresh = false) => {
	
	return async (dispatch) => {
		// Skip REQUEST dispatch if backgroundRefresh is true
		if (!backgroundRefresh) {
			dispatch(pharmacyPatientNotificationsRequest(types));
		}
		try {

			let params = {
				no_of_records: 20,
				page: page || 1,  // Default to page 1 if not provided
				noteoption: addTeamNoteData?.selectedNoteOptions,
				from_date: addTeamNoteData?.startDate,
				to_date: addTeamNoteData?.endDate,
				marknotes: addTeamNoteData?.marknotes ?? false
				// marknotes: false
			}


			if (addTeamNoteData?.search) {
				params.search = addTeamNoteData?.search
			}

			if (addTeamNoteData?.route) {
				params.route = addTeamNoteData?.route
			}

			if (addTeamNoteData?.selectedSystemGeneratedNotes === 'system_generated') {
				params.system_generated_notes = true
			}

			// Skip setAddTeamNoteData updates if backgroundRefresh is true
			if (!backgroundRefresh && typeof setAddTeamNoteData === 'function') {
				setAddTeamNoteData({
					...addTeamNoteData,
					initalListLoading: !appendData // Only show initial loading if not appending
				})
			}
			const response = await Axios.get(`${pharmacy_patient_notification_list}`, { params });
			if (response?.status === 200) {
				dispatch(pharmacyPatientNotificationsSuccess(response?.data, types, appendData));
				
				// Skip setAddTeamNoteData updates if backgroundRefresh is true
				if (!backgroundRefresh && typeof setAddTeamNoteData === 'function') {
					setAddTeamNoteData({
						...addTeamNoteData,
						initalListLoading: false
					})
				}

				if (type === 'PDF') {
					PreviewPdf(response?.data?.data)
				}

			} else {
				throw new Error(response);
			}
		} catch (error) {
			// Silently fail for background refresh - don't show error
			if (backgroundRefresh) {
				console.error('Background patient notifications refresh failed:', error);
				return; // Don't dispatch failure
			}
			
			if (error?.response) {
				dispatch(pharmacyPatientNotificationsFailure(error?.response, types));
			}
		}
	}
}

// Refresh a specific page in background without losing other pages' data
export const refreshPatientNotificationsPage = (currentPage, addTeamNoteData, types = "refreshPatientNotifications") => {
	return async (dispatch) => {
		// Don't dispatch REQUEST to avoid showing loading state
		try {
			let params = {
				no_of_records: 20,
				page: currentPage,
				noteoption: addTeamNoteData?.selectedNoteOptions,
				from_date: addTeamNoteData?.startDate,
				to_date: addTeamNoteData?.endDate,
				marknotes: addTeamNoteData?.marknotes ?? false
			}

			if (addTeamNoteData?.search) {
				params.search = addTeamNoteData?.search
			}

			if (addTeamNoteData?.route) {
				params.route = addTeamNoteData?.route
			}

			if (addTeamNoteData?.selectedSystemGeneratedNotes === 'system_generated') {
				params.system_generated_notes = true
			}

			const response = await Axios.get(`${pharmacy_patient_notification_list}`, { params });
			if (response?.status === 200) {
				dispatch(pharmacyPatientNotificationsRefreshPage(response?.data, currentPage, types));
			}
		} catch (error) {
			// Silently fail for background refresh - don't show error
			console.error('Background refresh failed:', error);
		}
	}
}

export const FetchPatientReminderNotificationList = (params, type = 'FetchPatientReminderNotificationList') => {
	return async (dispatch) => {
		dispatch(pharmacyPatientNotificationsRequest(type))
		try {
			const response = await Axios.get(`${p_reminder_nofication}`, { params })
			if (response?.status === 200) {
				dispatch(pharmacyPatientNotificationsSuccess(response?.data, type))
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyPatientNotificationsFailure(error?.response, type))
			}
		}
	}
}

export const pharmacyPreviewPdf = (path, formData) => {
	return async (dispatch) => {
		dispatch(pdf.previewPdfRequest())
		try {
			const params = {
				exportpdf: true,
			}
			if (formData.route) {
				params.route = formData?.route
			}
			if (formData.search) {
				params.search = formData?.search
			}
			const response = await Axios.get(`${path}`, { params })
			if (response?.status === 200) {
				dispatch(pdf.previewPdfSuccess(response?.data))
				PreviewPdf(response?.data?.data)

			} else {
				throw new Error(response)
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pdf.previewPdfFailure(error?.response?.data))
			}
		}
	}
}

export const deletePatientNotes = ({ noteID, setLoading, setDeletePatientNotes }) => {
	return async (dispatch) => {
		try {
			setLoading(true)
			const response = await Axios.delete(`delete-patient-notes/${noteID}`)
			if (response?.status === 200) {
				setDeletePatientNotes(false)
				
				// Remove from local state - API confirmed deletion
				dispatch(updatePatientNote(noteID, null, 'deleteNote'));
			} else {
				throw new Error(response)
			}
		} catch (error) {
			if (error?.response) {
				showToast('Something went wrong', 'error')
			}
		} finally {
			setLoading(false)
		}
	}
}

export const deleteMultipleNotes = ({ setLoading, setDeleteAllRecords, deleteRecord, setDeleteRecord, addTeamNoteData, setAddTeamNoteData }) => {
	return async (dispatch) => {
		try {
			setLoading(true)
			const response = await Axios.post(`delete-multiple-patient-notes`, {
				note_ids: deleteRecord
			})
			if (response?.status === 200) {
				setDeleteAllRecords(false)
				
				// Remove all deleted notes from local state - API confirmed deletion
				deleteRecord.forEach(noteId => {
					dispatch(updatePatientNote(noteId, null, 'deleteNote'));
				});
				
				setDeleteRecord([])
				showToast('Notes deleted successfully', 'success')

				// Refetch from API so list shows server data instead of "There are currently no notes available"
				const pageToFetch = addTeamNoteData?.pageNumber || 1
				const dataToSend = { ...addTeamNoteData, pageNumber: pageToFetch }
				dispatch(fetchPatientNotifications(pageToFetch, setAddTeamNoteData, dataToSend))
			} else {
				throw new Error(response)
			}
		} catch (error) {
			if (error?.response) {
				showToast('Something went wrong', 'error')
			}
		} finally {
			setLoading(false)
		}
	}
}

export const deleteAllSystemGeneratedNotes = ({ setLoading, setShowModal, addTeamNoteData, setAddTeamNoteData }) => {
	return async (dispatch) => {
		try {
			setLoading(true)
			// API supports POST (not DELETE)
			const response = await Axios.post(pharmacy_delete_all_system_generated_notes, {})
			if (response?.status === 200) {
				setShowModal(false)
				showToast('All system generated notes deleted successfully', 'success')

				// Refetch list with current filters (system_generated) so list updates
				const pageToFetch = addTeamNoteData?.pageNumber || 1
				const dataToSend = { ...addTeamNoteData, pageNumber: pageToFetch }
				dispatch(fetchPatientNotifications(pageToFetch, setAddTeamNoteData, dataToSend))
			} else {
				throw new Error(response)
			}
		} catch (error) {
			if (error?.response) {
				showToast('Something went wrong', 'error')
			}
		} finally {
			setLoading(false)
		}
	}
}